import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ModalRefreshTokenService } from '../../services/modal-refresh-token.service';
import { LoadingService } from '../../services/loading.service';
import { SessionService } from 'src/app/feature/home/services/session.service';
import { ErrorModalService } from '../../services/error-modal-service.service';
import { ExpiredTokenError } from '../../data/general-data';
import { SessionTimeoutService } from 'src/app/feature/login/services/session-timeout.service';
import { LoginService } from 'src/app/feature/login/services/login.service';
import { DialogDefaultsDirective } from '../../directives/dialog-defaults.directive';

@Component({
  selector: 'app-refresh-token-modal',
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule, DialogDefaultsDirective],
  templateUrl: './refresh-token-modal.component.html',
  styleUrls: ['./refresh-token-modal.component.scss'],
})
export class RefreshTokenModalComponent {
  showDialog: boolean = false;

  constructor(
    private modalRefreshTokenService: ModalRefreshTokenService,
    private loadingService: LoadingService,
    private sessionService: SessionService,
    private errorModalService: ErrorModalService,
    private sessionTimeoutService: SessionTimeoutService,
    private readonly loginService: LoginService,
  ) {
    this.modalRefreshTokenService.isModalVisible$.subscribe((isVisible) => {
      this.showDialog = isVisible;
    });
  }

  refreshToken() {
    this.modalRefreshTokenService.hide();
    this.loadingService.show();
    this.loginService.refreshTokenSession().subscribe({
      next: (res: any) => {
        this.sessionService.setSessionToken(res.tokenData || null);
        this.sessionService.setSessionRefreshToken(res.refreshToken || null);
        this.sessionService.setSessionName(res.userName || null);
        this.sessionTimeoutService.startCountdown(res.expiredIn);
        this.loadingService.hide();
      },
      error: (err: any) => {
        this.handleError(err);
      },
    });
  }

  handleError(err: any) {
    console.error(err);
    this.loadingService.hide();
    switch (err.status) {
      case 401:
        this.errorModalService.show(ExpiredTokenError);
        break;
      case 400:
      case 403:
      default:
        this.errorModalService.show(err.error);
        break;
    }
  }
}
